import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import HomePage from './pages/Home';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import OAuthCallback from './pages/Auth/OAuthCallback';
import CommunityPage from './pages/Community/CommunityPage';
import UserProfile from './pages/Profile/UserProfile';
import PostDetail from './pages/Community/PostDetail';
import NewPost from './pages/Community/NewPost';
import JobList from './pages/Job/JobList';
import TalentList from './pages/Talent/TalentList';
import NewsPage from './pages/News';
import NewsDetail from './pages/News/Detail';
import CardAnalysisPage from './pages/cardAnalysis';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/google/callback" element={<OAuthCallback />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/community/posts/new" element={<NewPost />} />
            <Route path="/community/posts/:id" element={<PostDetail />} />
            <Route path="/profile/:id" element={<UserProfile />} />
            <Route path="/jobs" element={<JobList />} />
            <Route path="/talent" element={<TalentList />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/card-analysis" element={<CardAnalysisPage />} />
            {/* 添加更多路由 */}
          </Routes>
        </Layout>
      </AuthProvider>
    </Router>
  );
}

export default App;
